import { axios } from '@carvana/purchase-utils';

export const completeDocumentUpload = caseId =>
  axios({
    method: 'post',
    url: `${process.env.CUSTOMER_VERIFICATIONS_API_URL}/api/v1/case/${caseId}/document-upload/complete`,
    data: {}
  }).then(res => res.data);

export const getCaseDefaults = () =>
  axios({
    method: 'get',
    url: `${process.env.CUSTOMER_VERIFICATIONS_API_URL}/api/v1/Case/default`
  }).then(res => res.data);

export const getAvailableOptionsForOrder = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/order/availableoptions`
  }).then(res => res.data);

export const getDashboard = async () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/dashboard`
  }).then(res => res.data);

export const pauseLockTimer = () =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/locktimer/pause`
  }).then(res => res.data);

export const pauseLockTimerForMarketplace = () =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/locktimer/PauseForMarketplaceVehicle`
  }).then(res => res.data);

export const postStartPurchaseWithVehicleId = vehicleId =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/purchase/startpurchase/${vehicleId}`
  }).then(res => res.data);

export const deleteCancelCurrentPurchase = payload =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/purchase/cancelpurchase`,
    data: payload
  }).then(res => res.data);

export const getDashboardSummary = async () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/dashboard/summary`
  }).then(res => res.data);

export const switchVehicle = (newVehicleId, reason) =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/purchase/switch-vehicle/${newVehicleId}/${reason}`
  }).then(res => res.data);

export const isFacebook = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/facebook`
  }).then(res => res.data);

export const bucketUserInExperiment = (userId, experimentName) =>
  axios
    .post(
      `${process.env.SPLITTEST_API_URL}/api/v2/buckets`,
      {
        identifier: userId,
        experimentName
      },
      {
        timeout: 4000
      }
    )
    .then(res => res.data)
    .catch(() => {});

export const getPaymentSummary = async () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v2/paymentcollection/summary/revieworder`
  })
  .then(res => res.data)
  .catch(() => {});